<template>
  <span>
    <div class="animated fadeIn">
      <b-row class="filters">
        <b-col cols="4">
          <b-form-group label="Request Date">
            <b-form-select v-model="dateRangeTypes" @change="onDateRangeChange">
              <option v-for="(type) in dateRangeTypes" v-bind:key="type" v-bind:value="type">{{type}}</option>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group label="From">
            <date-picker v-model="filters.dateFrom" :config="datePickerOptions" @dp-change="onSearch" size="sm">
            </date-picker>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group label="To">
            <date-picker v-model="filters.dateTo" :config="datePickerOptions" @dp-change="onSearch" size="sm">
            </date-picker>
          </b-form-group>
        </b-col>
      </b-row>
    </div>
  </span>
</template>

<script>
import { mapGetters } from 'vuex';

import { debounce } from 'lodash';

import { REQUEST_DATE, DATE_FORMAT, SEARCH_DEBOUNCE_TIME } from '@/shared/constants';
import { getDatesFromRangeString } from '@/shared/helpers';

export default {
  props: {
    handleSearch: Function,
    filters: Object,
    dateRange: String,
  },
  data() {
    return {
      dateRangeTypes: REQUEST_DATE,
      datePickerOptions: {
        format: DATE_FORMAT,
        useCurrent: false,
      },
    };
  },
  computed: {
    ...mapGetters('companies', ['companyById']),
    company() {
      return this.companyById(this.companyId);
    },
    companyId() {
      return this.$route.params.id;
    },
    ...mapGetters('address', [
      'addressesList',
      'addressTypes',
      'countryCodes',
    ]),
    ...mapGetters('account', ['gridSettingsById']),
    gridSettings() {
      //return this.gridSettingsById(GRID_ID.ADDRESSES);
      return null;
    },
    dateRangeType: {
      get: function () {
        return this.dateRange;
      },
      set: function () {
      },
    },
  },
  methods: {
    onSearch: debounce(function () {
      this.handleSearch(this.filters);
    }, SEARCH_DEBOUNCE_TIME),

    onDateRangeChange(value) {
      const { dateFrom, dateTo } = getDatesFromRangeString(value);

      Object.assign(this.filters, {
        dateFrom,
        dateTo,
      });

      this.$emit('range-changed', value);
    },
  },
};
</script>